import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const EmploymentHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/8cf3030fd34ef67170b2faf2ac2f0b72_EmploymentIcon.png, ' +
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/ef93ecf24a9fa30e5df3aeeea0b54e79_EmploymentIcon2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/28d2a3f0b68e2d6d4ab2ee7288228d92_EmploymentIcon3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/8cf3030fd34ef67170b2faf2ac2f0b72_EmploymentIcon.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
